var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAudioIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 49.407,
    viewBox: "0 0 53 49.407",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_676",
    x: 0,
    y: 0,
    width: 40.897,
    height: 49.407,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_677",
    x: 25.876,
    y: 8.473,
    width: 22.82,
    height: 32.46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_678",
    x: 28.918,
    y: 5.691,
    width: 24.082,
    height: 38.025,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(-1046 -1133)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1046, 1133)",
    filter: "url(#Path_676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_676-2",
    "data-name": "Path 676",
    d: "M40.116,22.418l-12.165,9.6a1.115,1.115,0,0,1-.689.226H20.148A1.142,1.142,0,0,0,19,33.37V42.4a1.142,1.142,0,0,0,1.148,1.129h7.058a1.244,1.244,0,0,1,.689.226l12.165,9.6a1.141,1.141,0,0,0,1.836-.9V23.321A1.093,1.093,0,0,0,40.116,22.418Z",
    transform: "translate(-10 -16.18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1046, 1133)",
    filter: "url(#Path_677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_677-2",
    "data-name": "Path 677",
    d: "M67.051,37.744a1.136,1.136,0,1,0-1.607,1.607,7.328,7.328,0,0,1,2.181,5.279,7.569,7.569,0,0,1-2.181,5.279,1.109,1.109,0,0,0,0,1.607,1.109,1.109,0,0,0,1.607,0,9.7,9.7,0,0,0,0-13.772Z",
    transform: "translate(-30.22 -22.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1046, 1133)",
    filter: "url(#Path_678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_678-2",
    "data-name": "Path 678",
    d: "M72.351,32.436a1.129,1.129,0,0,0-1.607,0,1.063,1.063,0,0,0,0,1.566,11.275,11.275,0,0,1,0,16.222,1.063,1.063,0,0,0,0,1.566,1.129,1.129,0,0,0,1.607,0,13.4,13.4,0,0,0,0-19.354Z",
    transform: "translate(-32.48 -20.41)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAudioIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/audio-icon.b6aba2ef.svg";
export { ForwardRef as ReactComponent };